import { transient, computedFrom } from 'aurelia-framework';

@transient()
export class State {

    private loadingCount = 0;
    private savingCount = 0;
    private uploadingCount = 0;
    private processingCount = 0;

    @computedFrom('loadingCount')
    public get loading(): boolean { return this.loadingCount > 0; }

    @computedFrom('savingCount')
    public get saving(): boolean { return this.savingCount > 0; }

    @computedFrom('uploadingCount')
    public get uploading(): boolean { return this.uploadingCount > 0; }

    @computedFrom('processingCount')
    public get processing(): boolean { return this.processingCount > 0; }

    @computedFrom('loadingCount', 'savingCount', 'uploadingCount', 'processingCount')
    public get busy(): boolean { return this.loadingCount > 0 || this.savingCount > 0 || this.uploadingCount > 0 || this.processingCount > 0; }

    @computedFrom('loadingCount', 'savingCount', 'uploadingCount', 'processingCount')
    public get display(): string { return this.toString(); }

    public beginLoad(): void {
        this.loadingCount++;
    }

    public endLoad(): void {
        if(this.loadingCount > 0) {
            this.loadingCount--;
        }
    }

    public beginSave(): void {
        this.savingCount++;
    }

    public endSave(): void {
        if(this.savingCount > 0) {
            this.savingCount--;
        }
    }

    public beginUpload(): void {
        this.uploadingCount++;
    }

    public endUpload(): void {
        if(this.uploadingCount > 0) {
            this.uploadingCount--;
        }
    }

    public beginProcessing(): void {
        this.processingCount++;
    }

    public endProcessing(): void {
        if(this.processingCount > 0) {
            this.processingCount--;
        }
    }

    public toString(): string {
        const results: string[] = [];
        if(this.loading) { results.push('Loading') }
        if(this.saving) { results.push('Saving') }
        if(this.uploading) { results.push('Uploading') }
        if(this.processing) { results.push('Processing') }
        if(results.length === 0) {
            return 'Ready';
        }
        else {
            return `Busy: (${results.join(', ')})`;
        }
    }

}
